import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminSiteContentResponse } from '@uw/core/api/models';
import { AdminSiteContent } from '@uw/core/models/admin-site-content.model';
import { AdminSiteContentService } from '@uw/core/services/admin-site-content.service';
import { SubHeaderService } from '@uw/themes/services/subheader.service';
import { map } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'uw-faqs',
    templateUrl: './faqs.component.html',
    styleUrls: ['./faqs.component.scss'],
    imports: [AsyncPipe]
})
export class FaqsComponent {

  private _adminSiteContent$ = this._adminSiteContentService.get().pipe(
    map(adminSiteContents => adminSiteContents.filter(x => x.adminContentPageMasterID == 1)[0]),
    map(adminSiteContent => adminSiteContent || {} as AdminSiteContentResponse)
  )


  readonly vm$ = this._adminSiteContent$.pipe(
    map(content => {

      this._subHeaderService.setTitle(this._translateService.currentLang == "en" ? content.adminSiteContentName! : content.adminSiteContentName_Fr!);
      this._subHeaderService.setSubTitle(null);

      var model = JSON.parse(this._translateService.currentLang == "en" ? content.content! : content.content_Fr!);

      for (let i = 0; i < model.faqs; i++) {

        model.faqs[i].display = false;

        for (let j = 0; j < model.faqs[i].faqs.length; j++) {
          model.faqs[i].faqs[j].display = false;
        }
      }
      return {
        currentLang: this._translateService.currentLang,
        model
      }
    })
  )


  constructor(
    private readonly _adminSiteContentService: AdminSiteContentService,
    private readonly _translateService: TranslateService,
    private readonly _subHeaderService: SubHeaderService
  ) {

  }
}
